'use client';

import { FC } from 'react';

export interface SelectTextOption {
    value: string;
    label: string;
}

export interface SelectTextProps {
    id?: string;
    name?: string;
    size?: 'small' | 'medium' | 'large';
    placeholder?: string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    value: string;
    testId: string;
    extendedClassName?: string;
    options: SelectTextOption[];
    error?: boolean;
    disabled?: boolean;
    allowEmpty?: boolean;
}

const SelectText: FC<SelectTextProps> = (props) => {
    const { id = '', name = '', size = 'small', error = false, disabled = false } = props;

    const defaultClassName =
        'select text-[100%] border-[#CED4DA] bg-white border rounded text-gray-900 block font-normal leading-6 bg-clip-padding focus:outline-none focus:border-[#86b7fe] focus:shadow-[inset_0_1px_1px_rgba(0,0,0,0.08),0_0_8px_rgba(102,175,233,0.6)]';

    // Sizes
    let sizeClassName = 'input-sm';
    if (size === 'medium') {
        sizeClassName = 'input-md';
    } else if (size === 'large') {
        sizeClassName = 'input-lg';
    }

    // Error
    let errorClassNames = '';
    if (error) {
        errorClassNames =
            'border border-red-500 focus:border-red-500 focus:shadow-[inset_0_1px_1px_rgba(0,0,0,0.08),0_0_8px_rgba(255,99,71,0.6)]';
    }

    let disabledClass = '';
    if (disabled) {
        disabledClass =
            'disabled:!border-custom-gray-06 disabled:bg-custom-gray-07 disabled:text-custom-black-01 disabled:opacity-100';
    }

    const classNames = [defaultClassName, sizeClassName, props.extendedClassName, errorClassNames, disabledClass].join(
        ' '
    );

    return (
        <select
            id={id}
            name={name}
            className={classNames}
            data-test-id={props.testId}
            onChange={props.onChange}
            value={props.value}
            disabled={disabled}
        >
            {props.placeholder && (
                <option disabled={true} value="" className="text-gray-400">
                    {props.placeholder}
                </option>
            )}
            {props.value === '' && !props.placeholder && !props.allowEmpty && (
                <option value="" disabled={true} className="text-gray-400"></option>
            )}
            {props.allowEmpty && <option value=""></option>}
            {props.options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default SelectText;
